const driverShifts = {
  driverShifts: 'Driver Shifts',

  driverLink: 'Driver Schedule App URL',

  filters: {
    areas: 'Zones',
    drivers: 'Drivers',
    suppliers: 'Suppliers',
    vehicles: 'Vehicles',
    locations: 'Locations',
    airportLocations: 'Airport Locations',
    attributes: 'Attributes',
  },

  calendarTypes: {
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
  },

  driverfilter: {
    all: 'All Drivers',
    withShift: 'Drivers with Shifts',
    withoutShifts: 'Drivers Without Shifts',
  },

  header: {
    create: 'Create',
    createMulti: 'Create Multiple',
    import: 'Import',
    switchButton: {
      label: 'View',
      table: 'Table',
      calendar: 'Calendar',
    },
  },

  moreActions: {
    delete: 'Delete',
  },
  toast: {
    error: {
      sameDate: 'From Date and To Date cannot be identical',
      badResponse: '[Driver Shift] bad server response',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
    },
  },
  headerButtons: {
    createBtn: 'Create',
    createMultiBtn: 'Create Multiple Shifts',
    deleteBtn: 'Delete',
  },

  table: {
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
    headers: {
      name: 'Driver',
      email: 'Driver',
      address: 'Address',
      firstTripDistance: '1st Trip Max Distance',
      addrLon: 'Lon',
      addrLat: 'Lat',
      at: 'Created At',
      by: 'Created By',
      areas: 'Zones',
      locations: 'Locations',
      attributes: 'Attributes',
    },
    cells: {
      name: {
        vehicle: 'Vehicle',
      },
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  create: {
    successToast: {
      message: 'Success Driver Shift Created!',
    },
    errorToast: {
      message: 'Error Occurred! Could Not Create Driver Shift',
    },

    multi: {
      successToast: {
        message: 'Success Drivers Shifts Created!',
      },
      errorToast: {
        message: 'Error! Select a valid weekday for the driver shift',
      },
    },
    modalAfter24: {
      header: 'Warning',
      body: 'Shifts that have already passed 24 hours cannot be modified',
    },
    modalBefore24: {
      header: 'Warning',
      body: 'Changes made within 24 hours of an existing shift require confirmation. Please confirm to proceed',
    },
  },

  update: {
    successToast: {
      message: 'Successfully updated {{count}} driver shifts',
    },
    errorToast: {
      message: 'Error Occurred! Could Not Update Driver Shift',
    },

    scopeModal: {
      title: 'Update Shift',
      body: 'Do you want to apply these changes to:',
      options: {
        single: 'This shift only',
        thisAndFuture: 'This and all future shifts',
        allEvents: 'All shifts',
        allEventsSubtitle: 'Excluding past shifts',
      },
      update: 'Update',
      cancel: 'Cancel',
    },

    formTabs: {
      informationTab: 'Information',
      historyTab: 'History',
    },
  },

  import: {
    title: 'Driver Shifts Upload',
  },

  delete: {
    scopeModal: {
      title: 'Delete Shift',
      body: 'Which shifts do you want to delete?',
      confirm: 'Delete',
    },
    modalError: {
      header: 'Error Occurred',
      body: 'Could Not Delete',
    },
    modalSuccess: {
      header: 'Success',
      body: ' - Shifts deleted successfully',
    },
    successToast: {
      message: 'Successfully deleted {{count}} driver shifts',
    },
  },

  modalRemoveConfirm: {
    header: 'Warning!',
    bodySingle: 'Are you sure you want to delete this shift?',
    bodyMultiple: 'Are you sure you want to delete these shifts?',
    confirmBtn: 'Delete',
  },

  modalRemoveSingelConfirm: {
    header: 'Delete Driver Shift',
    body: 'You are about to delete 1 driver shift',
  },

  form: {
    header: {
      createDriverShift: {
        title: 'Create',
      },

      createMultipleDriverShift: {
        title: 'Create Multiple',
      },

      updateDriverShift: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
        delete: 'Delete',
      },
    },

    information: {
      details: {
        header: 'Driver Details',
        fields: {
          driver: 'Driver',
          vehicle: '(Vehicle: {{currentVehicle}})',
        },
      },
      shiftDetails: {
        header: 'Shift Details',
        overnightShiftNote: 'Note: This is an overnight shift',
        multiDriverTimezoneNote: "Note: Times will be interpreted in each selected driver's local timezone",
        shiftDurationNote: 'Shift cannot be longer than 24 hours',
        fields: {
          fromDate: 'Start',
          toDate: 'End',
          template: 'Shift Template',
          address: 'Address',
          firstTripDistance: '1st Trip Max Distance',
          attributes: 'Attributes',
          areas: 'Zones',
          areasPriorityMode: {
            title: 'Mode',
            options: {
              allStops: 'All Stops',
              firstPickDrop: 'First Pick & Drop',
              legAOrigin: 'Leg A Origin',
            },
          },
          areasPriorityLevel: {
            title: 'Priority',
            options: {
              low: 'Low',
              medium: 'Medium',
              high: 'High',
              strict: 'Strict',
            },
          },
          vehicle: 'Current Vehicle',
          suppliers: 'Suppliers',
          allowSharedRides: 'Allow Shared Rides',
          ignoreDropoffTime: 'Ignore Drop-Off Time',
          ignoreDropoffTimeOptions: {
            byDriverSettings: 'By Driver Settings',
            enabled: 'Enabled',
            disabled: 'Disabled',
          },
          shiftBuffer: 'Shift Buffer',
        },
      },
      locationsSettings: {
        header: 'Locations Settings',
        fields: {
          locations: 'Locations',
          enableInBetweenRides: 'Enable In-Between Rides',
        },
      },
    },

    validations: {
      drivers: {
        required: 'Drivers is required',
        drivers: '',
      },
      driver: {
        required: 'Driver is required',
        driver: '',
      },
      start: {
        required: 'Start is required',
        start: '',
      },
      end: {
        required: 'End is required',
        endMustBeAfterStart: "A shift's end must be after its start.",
        end: '',
      },
      breakOutsideShift: 'Breaks must be within the shift hours',
    },
    select: 'Select',
    buttons: {
      addBreak: '+ Add Break',
    },
  },

  formMulti: {
    header: {
      createMultiDriverShift: {
        title: 'New Multi Drivers Shifts',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'EDIT MULTI DRIVERS SHIFTS',
      },
    },

    information: {
      details: {
        header: 'Driver Details',
        fields: {
          drivers: 'Drivers',
        },
      },
      shiftDetails: {
        header: 'Shift Details',
        fields: {
          fromDate: 'From Date',
          toDate: 'To Date',
          weeksDays: 'Week Days',
          fromHour: 'From Hour',
          tohour: 'To Hour',
          breakStart: 'Break Start',
          breakEnd: 'Break End',
        },
      },
    },
    validations: {
      drivers: {
        required: 'Drivers is required',
      },
      driver: {
        required: 'Driver is required',
      },
      start: {
        required: 'Start is required',
      },
      end: {
        required: 'End is required',
      },
    },
    select: 'Select',
  },

  totalDriverShifts: 'Total Driver Shifts',

  calendarTable: {
    filters: {
      areas: 'Zones',
      drivers: 'Drivers',
      suppliers: 'Suppliers',
      attributes: 'Attributes',
    },

    daily: {
      actions: {
        delete: 'Delete',
        deleteTooltip: "The driver's current day does not contain any shifts",
      },
      noResults: 'No Results Found',
      noResultsSubHeader: "We can't find any item matching your search",
      selectAll: 'Select All',
      selectAllPages: 'All {{limit}} items on this page are selected. ',
      btnSelectAllResults: ' Select all {{totalDrivers}} items',
      btnunselectAllResults: 'Clear Selection',
      totalDrivers: 'Total Drivers: {{total}}',
      totalShifts: 'Total Shifts: {{total}}',
    },
    weekly: {
      actions: {
        delete: 'Delete',
      },
    },
    emptyCell: {
      dayOff: 'Day Off',
    },
    headers: {
      driverName: 'Name',
      monday: 'Monday {{day}}',
      tuesday: 'Tuesday {{day}}',
      wednesday: 'Wednesday {{day}}',
      thursday: 'Thursday {{day}}',
      friday: 'Friday {{day}}',
      saturday: 'Saturday {{day}}',
      sunday: 'Sunday {{day}}',
    },
  },
};

export default driverShifts;
